import { ReactNode, FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import styles from './styles.module.scss';

interface Props {
  children: ReactNode;
  navigateTo: string;
  targetBlank?: boolean;
  onClick?: () => void;
}

const Link: FC<Props> = ({ children, navigateTo, targetBlank = false, onClick }): JSX.Element => {
  const target = targetBlank ? '_blank' : '_self';

  return (
    <RouterLink className={styles.link} target={target} to={navigateTo} onClick={onClick}>
      {children}
    </RouterLink>
  );
};

export default Link;
